import { render, staticRenderFns } from "./RevisitNote.vue?vue&type=template&id=49de70b5&scoped=true&"
import script from "./RevisitNote.vue?vue&type=script&lang=js&"
export * from "./RevisitNote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49de70b5",
  null
  
)

export default component.exports